module.exports = __webpack_public_path__ + "img/d201105-2.e6294288.jpg";